/* eslint-disable no-unused-vars */
import _ from 'lodash';
import { CalendarOutlined, PaperClipOutlined } from '@ant-design/icons';

export default {
  rowKey: 'id',
  displayColumns: [
    {
      title: 'Danh sách bài tập đã tạo',
      key: 'fileName',
      width: '88%',
      render: 'renderPreviewFile',
      style: {
        fontWeight: 600,
        cursor: 'pointer',
      },
      prefix: <PaperClipOutlined className='tw-mr-2' />,
    },
    {
      title: 'Kích thước',
      key: 'fileSize',
      width: '10%',
      render: 'renderNumber',
      formatString: '0.0 b',
      style: {
        fontWeight: '400',
      },
    },
    // {
    //   title: 'Loại',
    //   key: 'contentType',
    //   width: '1%',
    //   render: 'renderNoWrap',
    //   style: {
    //     fontWeight: '400',
    //   },
    // },
    {
      title: 'Ngày tạo',
      key: 'createdDate',
      width: '1%',
      render: 'renderDateTime',
      style: {
        fontWeight: '400',
      },
      prefix: <CalendarOutlined className='tw-mr-2' />,
    },
    {
      title: 'Loại bài tập',
      key: 'tags',
      width: '1%',
      render: 'renderNoWrap',
      style: {
        fontWeight: '400',
      },
      // prefix: <CalendarOutlined className='tw-mr-2' />,
    },
  ],
};
